<div class="padding-16 d-flex flex-column h-100">
	@if (isAddingNewBanner) {
		<div class="margin-top-10 width-full flex-grow-1 d-flex flex-column">
			<banner-add-form class="d-block h-100" [name]="'newBanner'" [(ngModel)]="newBanner" [isDuplicateName]="isDuplicateNameForForm" [themedHtmlEditor]="true" (addEntry)="onSaveEntry($event)" (cancel)="onCancelAddEntry()">
			</banner-add-form>
		</div>
	} @else {
		@if (banners?.length) {
			<div class="margin-top-10 width-full flex-grow-1 overflow-auto">
				@for (link of banners; track $index; let index = $index) {
					<banner-entry [name]="'link' + index" [(ngModel)]="banners[index]" [webcastId]="webcastId" [showToggleBtn]="true" [showPreviewBtn]="false" [showEditDeleteBtns]="true" (editEntry)="onEditEntry(index)" (updateEntry)="onUpdateEntry(index)" (deleteEntry)="onDeleteEntry(index)">
					</banner-entry>
				}
			</div>
		}
	}

	<div class="margin-top-10 d-flex flex-row justify-content-end align-items-center gap-1" [hidden]="isAddingNewBanner" [ngClass]="{ 'mt-auto': !!banners?.length }">
		<button type="button" [disabled]="isAddNewDisabled()" (click)="onAddNewClick()" vbBtnPrimary>
			{{ 'NewBanner' | translate }}
		</button>
		@if (banners?.length >= MAX_BANNERS) {
			<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'MaximumAmountReached' | translate">
			</vb-ui-tooltip>
		}
	</div>

</div>
